export const tr = {
    'build-date': 'Rapor oluşturma tarihi',
    download: 'Raporu indir',
    'end-date': 'Bitiş tarihi',
    id: 'ID',
    link: 'Raporu indir',
    'start-date': 'Başlama tarihi',
    status: 'Durum'
};
